import { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { staffbaseDarkTheme, staffbaseLightTheme } from '../../staffbaseTheme';

export const lightTheme: ExtensionDefinition = ThemeBlueprint.make({
  name: 'staffbase-light',
  params: {
    theme: {
      id: 'staffbase-light-theme',
      title: 'Light',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={staffbaseLightTheme} children={children} />
      ),
    },
  },
});

export const darkTheme: ExtensionDefinition = ThemeBlueprint.make({
  name: 'staffbase-dark',
  params: {
    theme: {
      id: 'staffbase-dark-theme',
      title: 'Dark',
      variant: 'dark',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={staffbaseDarkTheme} children={children} />
      ),
    },
  },
});
